import { render, staticRenderFns } from "./Kds2Board.vue?vue&type=template&id=eab90b30"
import script from "./Kds2Board.vue?vue&type=script&lang=js"
export * from "./Kds2Board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports